import { DateTimeRange, toTimestamp, useGraphCtx } from '@mi-front/core';
import React, { PropsWithChildren } from 'react';

interface Props {
  id: string;
  range: DateTimeRange;
}

export function TimeViewport(p: PropsWithChildren<Props>) {
  const { height, scale } = useGraphCtx();

  const clipPathId = `clip-path-${p.id}`;
  const x = scale(toTimestamp(p.range.from));
  const width = scale(toTimestamp(p.range.to))! - scale(toTimestamp(p.range.from))!;

  return (
    <React.Fragment>
      <defs>
        <clipPath id={clipPathId}>
          <rect x={x} y="0" width={width} height={height} />
        </clipPath>
      </defs>
      <g style={{ clipPath: `url(#${clipPathId})` }}>{p.children}</g>
    </React.Fragment>
  );
}
